// This icon file is generated automatically.
var PFontColorsOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.13 11.75H.87a.13.13 0 00-.12.13v1.24c0 .07.06.13.13.13h12.24c.07 0 .13-.06.13-.13v-1.24a.13.13 0 00-.13-.13zM2.96 10.5H4.3c.07 0 .13-.04.15-.1l.84-2.6H8.7l.83 2.6c.02.06.08.1.15.1h1.44a.15.15 0 00.1-.2L7.95.85a.15.15 0 00-.14-.1h-1.6a.15.15 0 00-.14.1L2.82 10.3v.05c0 .08.06.15.14.15zm4-8.06h.07l1.3 4.12h-2.7l1.33-4.12z", "fill-rule": "nonzero" } }] }, "name": "p-font-colors", "theme": "outlined" };
export default PFontColorsOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFontColorsOutlined.js
// module id = 3429
// module chunks = 0